import { render } from "./ProductToWarehouses.vue?vue&type=template&id=64bb6ada&scoped=true&ts=true"
import script from "./ProductToWarehouses.vue?vue&type=script&lang=ts"
export * from "./ProductToWarehouses.vue?vue&type=script&lang=ts"

import "./ProductToWarehouses.vue?vue&type=style&index=0&id=64bb6ada&lang=scss&scoped=true"

import exportComponent from "D:\\YellowBeardProject\\dobby\\dobbyshopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64bb6ada"]])

export default __exports__